import cn from "@/common/utils/classNames";

const DEFAULT_COUNT = 8;
const SKEL = "skeleton-shimmer bg-slate-200";

// عرض عنوان/پیش‌نمایش به‌ترتیب ردیف (همان nth-child قبلی)
const TITLE_W = ["w-[58%]", "w-[48%]", "w-[72%]", "w-[58%]", "w-[44%]"];
const PREVIEW_W = ["w-[82%]", "w-[65%]", "w-[82%]", "w-[55%]"];

export default function ChatsListSkeleton({ count = DEFAULT_COUNT, animate = true }) {
  return (
    <div
      className={cn(
        "chats-list-skeleton flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col overflow-hidden bg-white pb-1",
        animate && "motion-fade-in"
      )}
      dir="rtl"
      role="status"
      aria-busy="true"
      aria-label="در حال بارگذاری گفت‌وگوها"
    >
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className={cn(
            "chats-list-skeleton__item relative box-border flex min-h-[70px] w-full shrink-0 items-center gap-3 overflow-hidden bg-white px-3 py-[9px] after:absolute after:bottom-0 after:end-0 after:start-[76px] after:h-px after:bg-black/[0.06]"
          )}
        >
          <div className={cn(SKEL, "h-[52px] w-[52px] shrink-0 rounded-full")} />
          <div className="flex min-w-0 flex-1 flex-col gap-2.5">
            <div className="flex w-full min-w-0 items-center justify-between gap-2 overflow-hidden">
              <div
                className={cn(
                  SKEL,
                  "h-3 min-w-0 max-w-[calc(100%-44px)] flex-[1_1_auto] rounded-md",
                  TITLE_W[i] || TITLE_W[0]
                )}
              />
              <div className={cn(SKEL, "h-2.5 w-9 flex-none rounded-md")} />
            </div>
            <div className={cn(SKEL, "h-2.5 max-w-full flex-none self-start rounded-md", PREVIEW_W[i] || PREVIEW_W[0])} />
          </div>
        </div>
      ))}
    </div>
  );
}
